// Payment Gateway Configuration
// This file contains feature flags and settings for payment processing

export const PAYMENT_CONFIG = {
  // Feature flag - Toggle between real and mock payment processing
  // Set this to true to enable real Ziraat Bank 3D Secure payment processing
  // When false, the system uses mock payment processing for testing
  // TODO: Change to true when ready for production
  useRealPayment: true,

  // Ziraat Bank 3D Secure settings
  // Test mode should be true during development/staging
  testMode: true,

  // Return URL after 3D Secure authentication
  // Bank will redirect customers here after 3D authentication
  returnUrl: window.location.origin + '/payment/callback',
};

/**
 * Helper function to check if real payment is enabled
 * @returns true if real payment processing is enabled (3D Secure)
 */
export const isRealPaymentEnabled = (): boolean => {
  return PAYMENT_CONFIG.useRealPayment;
};

/**
 * Helper function to get payment return URL
 * @returns The URL where customers return after 3D authentication
 */
export const getPaymentReturnUrl = (): string => {
  return PAYMENT_CONFIG.returnUrl;
};
